import FoldersIcon from '@apps-common/ui-icons/Folders.jsx';

export default FoldersIcon;
